import { Card, FaIcon, FaIcons } from '@innovationnorway/component-library';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingSpinner } from '../../components/Shared/LoadingSpinner/LoadingSpinner';
import { AppContext } from '../../context/app-context';
import { useLocalizer } from '../../hooks';
import { apiClient, ApiSchema } from '../../lib/query/apiClient';
import { components } from '../../lib/query/nettbank.api.models';
import { tasksListLocalization } from './tasksList.localization';

type FeatureDto = ApiSchema<'FeatureDto'>;

export function TasksList() {
  const { state } = useContext(AppContext);
  const language = apiClient.useQuery('get', '/api/v1/Session/current/configuration').data?.language;

  const { data, isPending, error } = apiClient.useQuery('get', '/api/v1/Tasks/GetCustomerTasks', undefined, { staleTime: 0 });

  const navigate = useNavigate();

  const { typeSafeL } = useLocalizer('tasksListLocalization');
  const tasksListLocalizer = typeSafeL<typeof tasksListLocalization>;

  const taskNavigate = (
    task: {
      title?: string | null;
      bankAccountNumber?: string | null;
      type?: components['schemas']['CustomerTaskType'];
      applicationId?: string | null;
    },
    _features?: FeatureDto[],
  ) => {
    return navigate(`/applications/${task.applicationId}`);
  };

  if (isPending)
    return (
      <div className="mb-16">
        <h2 className="mt-4 mb-8">{tasksListLocalizer('tasks')}</h2>
        <LoadingSpinner />
      </div>
    );

  if (error) {
    return (
      <div className="mb-16">
        <h2 className="mt-4 mb-8">{tasksListLocalizer('tasks')}</h2>
        <div>{tasksListLocalizer('errorLoadingTasks')}</div>
      </div>
    );
  }

  if (!data || !data.length)
    return (
      <div className="mb-16">
        <h2 className="mt-4 mb-8">{tasksListLocalizer('tasks')}</h2>
        <div>{tasksListLocalizer('noTasksWaiting')}</div>
      </div>
    );

  return (
    <div className="mb-16">
      <h2 className="mt-4 mb-8">{tasksListLocalizer('tasks')}</h2>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        {data.map((task, index) => {
          return (
            <Card className="transition-all group hover:scale-[1.01]" boxShadow key={index} onClick={() => taskNavigate(task, state.configuration.features)}>
              <div className="flex justify-between ">
                <span className="text-sm">{task.applicationTitle}</span>
                <FaIcon className="m-1 mb-0" name={FaIcons.ArrowRight} />
              </div>

              <h5 className="mt-2 mb-4 group-hover:underline">{task.taskTitleTranslations[language ?? 'nb']}</h5>

              <span className="text-sm">{task.bankAccountNumber}</span>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
